import { atom } from "recoil";

const factorItemsAtom = atom({
  key: "@factor_items_atom",
  default: <Array<FactorItemT>>[],
});

export default factorItemsAtom;
